import { ArrowUpRight, Check } from 'lucide-react';
import SectionHeading from './SectionHeading.jsx';
import { valueCards } from '../data/siteData.js';

export default function About() {
  return (
    <section className="section section--light" id="rolam">
      <div className="container">
        <div className="about-intro">
          <SectionHeading
            eyebrow="Ismerj meg"
            title="A sport nemcsak a testemet, hanem az egész életemet formálta."
            text="25 éves vagyok, a Fitness Akadémián végeztem fitness instruktor és személyi edző képzést. A sport gyerekkorom óta meghatározó része az életemnek."
          />

          <div className="about-signature-card">
            <span className="about-signature">Martin</span>
            <p>Fitness instruktor és személyi edző</p>

            <a href="#kapcsolat">
              Ismerjük meg egymást
              <ArrowUpRight size={18} />
            </a>
          </div>
        </div>

        <div className="about-layout">
          <div className="about-image-wrap">
            <div className="about-image-main">
              <img
                src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=1200&q=88"
                alt="Személyi edző egy edzőteremben"
                loading="lazy"
              />
            </div>

            <div className="about-quote-card">
              <span>„</span>

              <p>
                A fejlődés nem egyik napról a másikra történik. A kitartás,
                a rendszeresség és a következetesség hozza meg az eredményt.
              </p>
            </div>

            <div className="about-mini-card">
              <Check size={18} />
              <span>Kezdőbarát, személyre szabott megközelítés</span>
            </div>
          </div>

          <div className="about-content">
            <div className="about-story">
              <span className="about-story-eyebrow">Az én történetem</span>

              <h3>
                A sport mindig is meghatározó része volt az életemnek.
              </h3>

              <p>
                Ötéves koromban kezdtem el focizni, és egészen 21 éves
                koromig ez volt az egyik legfontosabb része az életemnek.
                Emellett 12 és 18 éves korom között kézilabdáztam is.
              </p>

              <p>
                A súlyzós edzéssel 17 éves koromban ismerkedtem meg,
                később pedig egyre komolyabban kezdtem vele foglalkozni.
                Nagyon hamar beleszerettem, mert nemcsak a fizikai fejlődés
                fogott meg, hanem az az életvitel is, amit ez a sport képvisel.
              </p>

              <p>
                A rendszeres edzésnek köszönhetően magabiztosabbnak érzem
                magam a mindennapokban, kitartóbb és következetesebb lettem,
                és ez az élet más területein is rengeteget segít.
              </p>

              <p>
                Ezt a szemléletet szeretném átadni a klienseimnek is.
                Nemcsak abban szeretnék segíteni, hogy jobban nézz ki,
                hanem abban is, hogy erősebbnek, magabiztosabbnak és
                céltudatosabbnak érezd magad.
              </p>

              <div className="about-credentials">
                <span>25 éves</span>
                <span>8+ év súlyzós edzés</span>
                <span>Fitness instruktor</span>
                <span>Személyi edző</span>
                <span>16 év labdarúgás</span>
                <span>6 év kézilabda</span>
              </div>
            </div>

            <div className="personalized-box">
              <span>Nincs sablonprogram</span>

              <h3>Minden tervet személyesen neked készítek el.</h3>

              <p>
                Figyelembe veszem a céljaidat, az edzettségi szintedet,
                az időbeosztásodat, az étkezési szokásaidat és az esetleges
                korlátaidat is.
              </p>
            </div>
          </div>
        </div>

        <div className="value-grid about-value-grid">
          {valueCards.map(({ icon: Icon, eyebrow, title, text }) => (
            <article className="value-card" key={title}>
              <div className="value-card-icon">
                <Icon size={23} />
              </div>

              <span>{eyebrow}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}